import React from "react";
import PropTypes from "prop-types";
import px2rem from '../../utils/px2rem';
import utils from "../../utils/utils";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import "./style.less";

class PipelineTopic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.topicSwiper = null;
    this.headLinesRef = null;
  }

  componentDidMount() {
    const { itemList = [] } = this.props.config;
    if (itemList.length > 0) {
      this.topicSwiper = new Swiper('.topic-swiper', {
        direction: 'vertical',
        autoplay: itemList.length > 1,
        speed: 500,
        loop: true,
        spaceBetween: 20,
        allowTouchMove: false, // 禁止触摸滑动
        on: {
          click: (swiper, event) => {
            const url = event.target.getAttribute('dataurl') || event.target.parentNode.getAttribute('dataurl');
            utils.jumpToUrl(this.props.routeParams, url, url, {}, -1, this.props, false);
          }
        }
      }); 
    }

    window.addEventListener('scroll', this.scrollEvent);
  }

  componentWillUnmount() {
    this.topicSwiper = null;
  }

  scrollEvent = () => {
    const { topicTheme = '' } = this.props.config.baseConfig;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollHeight >= 200) {
      this.headLinesRef.setAttribute('class', `pipeline-headlines ${topicTheme === '浅色模式' ? 'light' : 'dark'} hide`)
    } else {
      this.headLinesRef.setAttribute('class', `pipeline-headlines ${topicTheme === '浅色模式' ? 'light' : 'dark'} show`)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  render() {
    const { baseConfig = {}, itemList = [] } = this.props.config;
    let { topicTheme = '', titleImage = '', expireTime = '' } = baseConfig;
    
    if (!expireTime) {
      return null;
    }

    const currentTime = new Date().getTime();
    expireTime = expireTime.replace('T', ' ');

    if (new Date(expireTime).getTime() < currentTime) {
      // 话题已过期
      return null;
    }

    if (!titleImage) {
      // 没有配置标题图片时，基于topicTheme使用兜底图片
      if (topicTheme === '浅色模式') {
        titleImage = 'https://static.shihuocdn.cn/admin/files/20230821/4aa33bd68bbe0b2559c7a0cd207aaff1.png';
      } else {
        titleImage = 'https://static.shihuocdn.cn/admin/files/20230821/1e6490f79e68e28ac6edc864a57b3143.png';
      }
    }

    return (
      <div
        ref={ele => {
          this.headLinesRef = ele;
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className={
          topicTheme === '浅色模式'
            ? 'pipeline-headlines show light'
            : 'pipeline-headlines show dark'
        }
        {...this.props['customAttributes']}
        style={{
          top: this.props.navigationBarHeight + 4
        }}
      >
        <div className="topic-title">
          <img src={titleImage} alt="" />
        </div>
        {
          itemList.length > 0 && (
            <div className="topic-swiper swiper-container">
              <div className="topic-lottery-all swiper-wrapper">
                {
                  itemList.map((item, index) => {
                    return (
                      <div 
                        className="topic-lottery-item swiper-slide"
                        key={index}
                        dataUrl={item.topicUrl}
                      >
                        
                        <p style={{ color: topicTheme === '浅色模式' ? '#333' : '#fff' }}>{item.topicTitle}</p>
                        { item.topicHot === '是' && <img src="https://static.shihuocdn.cn/admin/files/20230821/ea4bdd455ad13fefa8231c72a8614026.png" alt="" className="hot-tag" /> }
                      </div>
                    )  
                  })
                } 
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

PipelineTopic.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineTopic };
export default PipelineTopic;



// WEBPACK FOOTER //
// ./components/pipeline-headlines/index.js